import React from 'react';

import { Tbody, Thead, Tr } from '@lightspeed/cirrus-table';
import { Checkbox } from '@lightspeed/flame/Checkbox';
import { Box } from '@lightspeed/flame/Core';
import { Input } from '@lightspeed/flame/Input';
import { Text } from '@lightspeed/flame/Text';

import Format from 'root/apps/helpers/format';

import {
  MatrixListingTD,
  MatrixListingTH,
  NO_IMAGE_URL,
  TableInCard,
} from '../B2BItemsListing.styles';
import { findMSRP } from '../utils';
import B2BMatrixContext from './B2BMatrixContext';

const B2BMatrixPricingListing = () => {
  const context = React.useContext(B2BMatrixContext);
  const selectedItems = context.items.filter((item) => item.selected);
  const toggleUseDefaultCost = context.toggleUseDefaultCost;
  const currencySymbol = window.merchantos.locale.currency_symbol;

  return (
    <>
      <Box mt={1} mb={4}>
        <Text>Add or modify pricing options for your selected variants.</Text>
      </Box>
      <Checkbox
        id="apply-default-cost-to-all"
        label="Apply default cost and price to all items"
        description="When selected, the default cost & price for the first item will be automatically applied to all items."
        checked={context.useDefaultCost}
        onChange={toggleUseDefaultCost}
      />
      <Box mx="-1.5rem" mt="1.5rem">
        <TableInCard>
          <Thead>
            <Tr>
              <MatrixListingTH>Image</MatrixListingTH>
              <MatrixListingTH>Item Description</MatrixListingTH>
              <MatrixListingTH>UPC</MatrixListingTH>
              <MatrixListingTH>MSRP</MatrixListingTH>
              <MatrixListingTH>Default cost</MatrixListingTH>
              <MatrixListingTH>Price</MatrixListingTH>
            </Tr>
          </Thead>
          <Tbody>
            {selectedItems.map((item, index) => {
              const b2bItem = item.b2bItem;
              const b2bMsrp = findMSRP(b2bItem);
              const b2bMsrpLabel = b2bMsrp
                ? Format.toMoney(b2bMsrp.amount, b2bMsrp.currency)
                : 'N/A';

              return (
                <Tr key={`${b2bItem.upc}_${b2bItem.id}`}>
                  <MatrixListingTD>
                    <img
                      src={b2bItem.images?.[0]?.image_url || NO_IMAGE_URL}
                      alt={`${b2bItem.color} ${b2bItem.size} ${b2bItem.brand_name} ${b2bItem.name}`}
                    />
                  </MatrixListingTD>
                  <MatrixListingTD className="notranslate">
                    <p>{`${b2bItem.name} ${b2bItem.size ? `/ ${b2bItem.size}` : ''} ${
                      b2bItem.color ? `/ ${b2bItem.color}` : ''
                    } ${b2bItem.season ? `/ ${b2bItem.season}` : ''}`}</p>
                  </MatrixListingTD>
                  <MatrixListingTD className="notranslate">{b2bItem.upc}</MatrixListingTD>
                  <MatrixListingTD className="notranslate">{b2bMsrpLabel}</MatrixListingTD>
                  <MatrixListingTD>
                    {context.useDefaultCost && index !== 0 ? (
                      <Input
                        data-test="default-cost-input"
                        min="0"
                        prefix={currencySymbol}
                        type="number"
                        id={`default-cost-${b2bItem.id}`}
                        name={`default-cost-${b2bItem.id}`}
                        key={`default-cost-${b2bItem.id}-matched`}
                        placeholder="0.00"
                        value={context.items[0].cost}
                        disabled={true}
                      />
                    ) : (
                      <Input
                        data-test="default-cost-input"
                        min="0"
                        prefix={currencySymbol}
                        type="number"
                        id={`default-cost-${b2bItem.id}`}
                        name={`default-cost-${b2bItem.id}`}
                        key={`default-cost-${b2bItem.id}`}
                        placeholder="0.00"
                        defaultValue={item.cost}
                        onChange={(e) => context.setItemCost(item.index, e.target.valueAsNumber)}
                      />
                    )}
                  </MatrixListingTD>
                  <MatrixListingTD>
                    {context.useDefaultCost && index !== 0 ? (
                      <Input
                        data-test="price-input"
                        min="0"
                        prefix={currencySymbol}
                        type="number"
                        id={`price-${b2bItem.id}`}
                        name={`price-${b2bItem.id}`}
                        key={`price-${b2bItem.id}-matched`}
                        placeholder="0.00"
                        value={context.items[0].price}
                        disabled={true}
                      />
                    ) : (
                      <Input
                        data-test="price-input"
                        min="0"
                        prefix={currencySymbol}
                        type="number"
                        id={`price-${b2bItem.id}`}
                        name={`price-${b2bItem.id}`}
                        key={`price-${b2bItem.id}`}
                        placeholder="0.00"
                        defaultValue={item.price}
                        onChange={(e) => context.setItemPrice(item.index, e.target.valueAsNumber)}
                      />
                    )}
                  </MatrixListingTD>
                </Tr>
              );
            })}
          </Tbody>
        </TableInCard>
      </Box>
    </>
  );
};

export default B2BMatrixPricingListing;
